<script setup>
import { onMounted, reactive, ref } from "vue";
import { apiQuery } from "@/api/j24api";

const outstanding = reactive([]);
const completedToday = reactive([]);
const inProgress = reactive([]);

const selectedTab = ref("outstanding");
const searchValue = ref("");
const loading = ref(false);

const headers = [
  { text: "Name", value: "name", sortable: true },
  { text: "Status", value: "status", sortable: true },
  { text: "Stream", value: "stream" },
];

const completedHeaders = [
  ...headers,
  { text: "Started", value: "startDate", sortable: true },
  { text: "Completed", value: "endDate", sortable: true },
  { text: "Result", value: "message", sortable: true },
];

function searchFields(headers) {
  var fields = [];
  headers.forEach((header) => {
    fields.push(header.value);
  });
  return fields;
}

onMounted(() => {
  getData();
});

async function getData() {
  loading.value = true;
  var result = await apiQuery("ELA", "patching/patchitems", {
    apiAction: "PatchRequests",
    type: "status",
  });

  if (result.outstanding) {
    outstanding.push(...result.outstanding);
  }
  if (result.completedToday) {
    completedToday.push(...result.completedToday);
  }
  if (result.inProgress) {
    inProgress.push(...result.inProgress);
  }
  loading.value = false;
}
</script>

<template>
  <v-row>
    <v-col cols="4">
      <v-card>
        <v-card-title>Outstanding</v-card-title>
        <v-card-text>
          <v-row>
            <v-spacer />
            <v-col>
              <h1 v-if="outstanding.length">{{ outstanding.length }}</h1>
              <h1 v-else>0</h1>
            </v-col>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="4">
      <v-card>
        <v-card-title>Completed Today</v-card-title>
        <v-card-text>
          <v-row>
            <v-spacer />
            <v-col>
              <h1 v-if="completedToday.length">{{ completedToday.length }}</h1>
              <h1 v-else>0</h1>
            </v-col>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="4">
      <v-card>
        <v-card-title>In Progress</v-card-title>
        <v-card-text>
          <v-row>
            <v-spacer />
            <v-col>
              <h1 v-if="inProgress.length">{{ inProgress.length }}</h1>
              <h1 v-else>0</h1>
            </v-col>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-tabs v-model="selectedTab" color="#e7541e">
    <v-tab value="outstanding">Outstanding</v-tab>
    <v-tab value="completedToday">Completed Today</v-tab>
    <v-tab value="inprogress">In Progress</v-tab>
  </v-tabs>

  <v-window v-model="selectedTab">
    <v-window-item value="outstanding">
      <v-row class="mt-3">
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-text-field
            v-model="searchValue"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            clearable
            density="compact"
            class="mb-4"
            hide-details
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <EasyDataTable
            :headers="headers"
            :items="outstanding"
            :search-field="searchFields(headers)"
            :search-value="searchValue"
            :loading="loading"
            theme-color="#e7541e"
          >
          </EasyDataTable>
        </v-col>
      </v-row>
    </v-window-item>

    <v-window-item value="completedToday">
      <v-row class="mt-3">
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-text-field
            v-model="searchValue"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            clearable
            density="compact"
            class="mb-4"
            hide-details
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <EasyDataTable
            :headers="completedHeaders"
            :items="completedToday"
            :search-field="searchFields(completedHeaders)"
            :search-value="searchValue"
            :loading="loading"
          >
            <template #expand="item">
              <v-table v-if="item.logs" density="compact">
                <thead>
                  <tr>
                    <th class="font-weight-bold">Time</th>
                    <th class="font-weight-bold">Message</th>
                    <th class="font-weight-bold">Extended Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="log in item.logs.slice().reverse()" :key="log">
                    <td>{{ log.timestamp }}</td>
                    <td>{{ log.message }}</td>
                    <td>
                      <v-textarea
                        v-if="log.body"
                        rows="5"
                        variant="outlined"
                        :model-value="log.body"
                        readonly
                      />
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </template>
          </EasyDataTable>
        </v-col>
      </v-row>
    </v-window-item>

    <v-window-item value="inprogress">
      <v-row>
        <v-col cols="12">
          <EasyDataTable
            :headers="headers"
            :items="inProgress"
            :search-field="['cfbundleidentifier', 'path']"
            :search-value="searchValue"
            :loading="loading"
          >
          </EasyDataTable>
        </v-col>
      </v-row>
    </v-window-item>
  </v-window>
</template>
